<template>
  <div>
    <div class="listSummary">
      <div class="checkbox">
        <input type="checkbox" name="" id="all_channel" v-model="chkAll">
        <label for="all_channel">{{locale.all}}</label>
      </div>
      <span v-if="chkChannel.length > 0" class="chkCnt">{{`${locale.select} ${chkChannel.length} / ${channel.length}`}}</span>
      <button type="button" class="btn sizeXs btnRed btnReset" @click="delChannel" :disabled="chkChannel.length === 0">{{locale.delete}}</button>
      <p class="cnt">
        {{locale.all}} <span class="colorPrimary f_medium">{{channel.length}}</span> / {{list.length}}
      </p>
    </div>
    <div class="chList">
      <ChannelCreate
        :locale="locale"
        :genre="genre"
        :lang="lang" />
      <ChannelItem v-for="item in channel"
        :key="item.id"
        :item="item"
        :locale="locale"
        :genre="genre"
        :lang="lang" />
    </div>
  </div>
</template>

<script>
import ChannelItem from '@/components/Tv/Item.vue'
import ChannelCreate from '@/components/Tv/Create.vue'

export default {
  props: [
    'locale',
    'list',
    'genre',
    'lang'
  ],
  components: {
    ChannelItem,
    ChannelCreate
  },
  computed: {
    listView () {
      return this.$store.state.tv.listView
    },
    getFilter () {
      return this.$store.getters['tv/getFilter']
    },
    channel () {
      const lang = this.getFilter.lang
      const genre = this.getFilter.genre
      const word = this.getFilter.word
      // 상태 필터 후 전체 리스트 리턴
      // let list = this.list ? listService(this.list) : []
      let list = this.list || []
      if (!!word && word.trim().length !== 0) {
        // 검색어
        list = list.filter(x => x.name.toLowerCase().includes(word) || word.includes(x.no))
      }
      if (genre) {
        // 장르
        list = list.filter(x => genre.includes(x.genre))
      }
      if (lang) {
        // 언어
        list = list.filter(x => lang.includes(x.lang))
      }
      return list
    },
    unLang () {
      const lang = this.getFilter.lang
      return this.list.filter(x => !lang.includes(x.lang))
    },
    chkChannel () {
      return this.channel.filter(x => x.checked).map(x => x.id)
    }
  },
  watch: {
    chkAll (isChkAll) {
      this.$store.commit('tv/chkAllChannel', isChkAll)
    }
  },
  data () {
    return {
      chkAll: false
    }
  },
  methods: {
    delChannel () {
      if (window.confirm(this.locale.confirm_channel_delete_all)) {
        const delIds = this.chkChannel
        const list = this.channel.filter(x => !delIds.includes(x.id))
        this.$store.commit('onLoading', true)
        this.$store.dispatch('tv/setChannel', list).then(() => {
          this.$store.dispatch('tv/getChData').then(() => {
            alert(this.locale.complete_delete)
            this.$store.commit('onLoading', false)
          })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.listSummary {
  display: flex;
  align-items: center;
  margin-bottom: 0.5em;
}
.cnt {
  margin-left: auto;
}
.noData {
  padding: 120px 30px 200px;
  text-align: center;
  font-size: 1.2em;
  &:before {
    content: "";
    display: block;
    height: 64px;
    margin-bottom: 30px;
    background: url('~@/assets/img/ico_search.svg') 50% 50% / contain no-repeat;
    opacity: 0.2;
  }
}
.chkCnt {
  margin-right: 0.5em;
}
.btnReset[disabled] {
  opacity: 0.5;
}
</style>
